import { render, staticRenderFns } from "./FeatureBlocks.vue?vue&type=template&id=68fe1988&scoped=true&"
import script from "./FeatureBlocks.vue?vue&type=script&lang=js&"
export * from "./FeatureBlocks.vue?vue&type=script&lang=js&"
import style0 from "./FeatureBlocks.vue?vue&type=style&index=0&id=68fe1988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fe1988",
  null
  
)

export default component.exports